import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  action?: { label: string; to: string };
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  eyebrow,
  action,
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-primary-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-2 text-sm md:text-base text-foreground-600">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3 whitespace-nowrap">
        {children}
        {action && (
          <Link
            to={action.to}
            className="inline-flex items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            {action.label}
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>
    </div>
  );
}